import { Link } from "react-router-dom";
import { useI18n } from "../i18n/LanguageProvider";

/** Official Centauros wordmark. Uses the raw provided asset, never redrawn. */
export function Logo({ className = "", height = 26, dark = false }) {
  const { locale } = useI18n();
  return (
    <Link
      to={`/${locale}`}
      aria-label="Centauros"
      data-testid="logo-home-link"
      className={`inline-flex items-center ${className}`}
    >
      <img
        src="/centauros-logo.png"
        alt="Centauros"
        style={{ height, filter: dark ? "invert(1)" : "none" }}
        className="w-auto select-none"
        draggable="false"
      />
    </Link>
  );
}
